// Spec Category Constants
export const SpecCategory = {
  GPU: 0,
  CPU: 1,
  VGPU: 2,
} as const

export type SpecCategoryType = (typeof SpecCategory)[keyof typeof SpecCategory]
